<template>
  <div class="row mx-auto my-auto">
    <div v-for="(video, index) in videos" :key="index">
      <div class="card card-body ml-2 mr-2 mt-3">
      <iframe
        width="auto"
        height="215"
        allowfullscreen="allowfullscreen"
        :src="'https://www.youtube.com/embed/' + video.id.videoId"
      >
      </iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      videos: null,
    };
  },
  created() {
    this.videos = JSON.parse(this.data.data);
    this.videos = this.videos.items;
  },
};
</script>
